export default __webpack_public_path__ + "static/media/xray-active.a56eb2b0.svg";